import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import assetPreloader from '../services/assetPreloader';

/**
 * Hook personalizado para precarregamento preditivo de assets
 * Antecipa quais rotas o usuário provavelmente visitará em seguida
 * e pré-carrega seus assets em segundo plano
 */
const usePredictivePreloading = () => {
  const location = useLocation();

  useEffect(() => {
    // Quando a rota muda, precarregar assets de possíveis próximas rotas
    const currentPath = location.pathname;
    
    // Breve atraso para garantir que os assets essenciais da rota atual sejam priorizados
    const timer = setTimeout(() => {
      assetPreloader.preloadPredictiveAssets(currentPath);
    }, 2000);
    
    return () => {
      clearTimeout(timer);
    };
  }, [location.pathname]);
};

export default usePredictivePreloading; 